import View from "app/core/View";

export default View.extend({

    /**
     * Override
     * @param template The content template to create in the view
     * @param ViewModel The model class for the view
     */
    init: function(template, ViewModel) {
        View.fn.init.call(this, template, {
            model: new ViewModel(),
            wrap: false
        });

        this.model.bind("windowClosed", $.proxy(this._windowClosed, this));
    },

    /**
     * Opens the popup
     * @returns {promise}
     */
    open: function() {
        this.render($(document.body));
        return this.model.open.apply(this.model, arguments);
    },

    /**
     * Close the popup (parent sometimes needs to close the popup after post-processing)
     */
    close: function() {
        this.model.close();
    },

    _windowClosed: function() {
        this.destroy();
    },

    /**
     * Override
     * clean up the class
     */
    destroy: function() {
        this.model.unbind("windowClosed");
        this.close();
        View.fn.destroy.apply(this, arguments);
    }
});
